import { render, staticRenderFns } from "./WidgetProductReviewsGalleryPc.vue?vue&type=template&id=ec50c2be"
import script from "./WidgetProductReviewsGalleryPc.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsGalleryPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports